import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import {ErrorService} from '../../services/error.service';

@Component({
  selector: 'sb-clipboard-list-input',
  templateUrl: './sb-clipboard-list-input.component.html',
  styleUrls: ['./sb-clipboard-list-input.component.scss'],
  standalone: false,
})
export class SbClipboardListInputComponent implements OnInit {
  public entries: string[];
  @Output() entriesChanged: EventEmitter<string[]>;

  constructor(
    private clipboard: Clipboard,
    private errorHandler: ErrorService
  ) {
    this.entries = [];
    this.entriesChanged = new EventEmitter<string[]>();
  }

  ngOnInit(): void {}

  public readFromClipboard(): void {
    navigator.clipboard
      .readText()
      .then((input: string) => {
        const arr = input.match(/[^\r\n]+/g);
        const clearArr = arr.filter(x => x.trim() !== '');
        for (const value of clearArr) {
          this.addEntry(value);
        }
        this.entriesChanged.emit(this.entries);
      })
      .catch(error => {
        this.errorHandler.errorHandler(error);
      });
  }

  public addEntry(value?: string): void {
    value = value?.trim();
    if (value?.length > 0) {
      this.entries.push(value);
    }
  }

  public addEmptyEntry(): void {
    this.entries.unshift('');
    this.entriesChanged.emit(this.entries);
  }

  public delete(index: number): void {
    if (index > -1) {
      this.entries.splice(index, 1);
      this.entriesChanged.emit(this.entries);
    }
  }
}
